import { c as e } from "../../../../index.esm-BeDSGXP5.js";
import { css as o } from "styled-components";
import "../../../../colors-C72eWVhK.js";
import { SCREEN_WIDTHS as t } from "../../constants/constants.mjs";
const a = {
  stacked: {
    flexFlow: [
      "column"
    ],
    alignItems: [
      "center"
    ],
    textAlign: [
      "center"
    ]
  },
  condensed: {
    flexFlow: [
      "row",
      null,
      "column"
    ],
    alignItems: [
      "flex-start",
      null,
      "center"
    ],
    textAlign: [
      "left",
      null,
      "center"
    ]
  }
}, m = {
  stacked: {
    width: [
      "6.4rem"
    ],
    height: [
      "6.4rem"
    ]
  },
  condensed: {
    width: [
      "3.2rem",
      null,
      "6.4rem"
    ],
    height: [
      "3.2rem",
      null,
      "6.4rem"
    ],
    mr: [
      "sm",
      null,
      0
    ]
  }
}, d = {
  wrapper: ({ theme: n }) => /* @__PURE__ */ o([
    "flex-direction:column;flex-wrap:nowrap;align-items:center;",
    ""
  ], e({
    color: n.componentColors.iconSummaryPanel.heading,
    paddingTop: [
      "xs",
      null,
      "md"
    ],
    paddingBottom: [
      "0",
      "md"
    ],
    paddingX: [
      "sm",
      "lg"
    ]
  })),
  innerWrapper: () => /* @__PURE__ */ o([
    "",
    " justify-content:space-between;flex-wrap:nowrap;position:relative;width:100%;max-width:",
    ";"
  ], e({
    display: [
      "block",
      null,
      "flex"
    ]
  }), t.EIGHT_COLUMN_NO_PADDING),
  itemWrapper: ({ theme: n, colorVariant: l, mobileLayoutVariant: r }) => /* @__PURE__ */ o([
    "",
    " & > span{",
    "}"
  ], e({
    color: n.componentColors.iconSummaryPanel.heading,
    borderRadius: [
      "0.4rem",
      null,
      "0.8rem"
    ],
    padding: [
      "sm",
      null,
      "lg"
    ],
    marginBottom: [
      "sm"
    ],
    bg: l === "dark" ? n.componentColors.iconSummaryPanel.panel.dark : [
      "transparent"
    ],
    width: [
      "100%",
      null,
      "32%"
    ],
    ...a[r]
  }), e({
    ...m[r]
  })),
  iconWrapper: ({ theme: n }) => /* @__PURE__ */ o([
    "flex-shrink:0;",
    ""
  ], e({
    color: n.componentColors.iconSummaryPanel.icon,
    mb: [
      "xs"
    ]
  })),
  line: ({ theme: n }) => /* @__PURE__ */ o([
    "",
    ";stroke-width:0.6rem;stroke-linecap:butt;stroke-dasharray:7;"
  ], e({
    stroke: n.componentColors.iconSummaryPanel.icon
  }))
};
export {
  d as default
};
